import Vue from 'www/vue_components'
import { initI18n } from 'www/utils'
import vuetify from 'www/modules/vuetify-plugin'
import ReviewsTags from 'www/vue_components/common/ReviewsTags/ReviewsTags.vue'

const mount = async () => {
  const el = document.querySelector('.vue-reviews-tags')

  if (!el) {
    return
  }

  await initI18n({ bundle: 'vue_components/common/ReviewsTags' })

  const instance = new Vue({
    name: 'ReviewsTagsRoot',
    vuetify,
    components: { ReviewsTags },
  })

  instance.$mount(el)
}

mount()
